import React from "react";
import { Link } from "react-router-dom";
import {
  chakra,
  Image,
  Menu,
  MenuItem,
  MenuList,
  useDisclosure,
  MenuButton,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
} from "@chakra-ui/react";
import { FaFlag, FaBars } from "react-icons/fa";

import styles from "./Styles.module.css";
import tanjiro from "assets/tanjiro.png";

export default function Header() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  let language = localStorage.getItem("language");

  const newLanguage = require(`language/${language!}.json`);

  function setLanguage(lang: any) {
    localStorage.setItem("language", lang);

    window.location.replace(window.location.href);

    return;
  }

  return (
    <chakra.div className={styles.background}>
      <chakra.div className={styles.container}>
        <chakra.nav className={styles.navbar}>
          <Sidebar />

          <chakra.div className={styles.title}>
            <Image
              src={tanjiro}
              alt="logo do bot tanjiro"
              className={styles.logo}
            />
            &nbsp; Tanjiro#2415
          </chakra.div>

          <chakra.ol className={styles.nav}>
            <chakra.li className={styles.navitem}>
              <Link to={`/`}>{newLanguage.header.home}</Link>
            </chakra.li>
            <chakra.li className={styles.navitem}>
              <Link to={`/guidelines`}>{newLanguage.header.guideline}</Link>
            </chakra.li>
            <chakra.li className={styles.navitem}>
              <Link to={`/commands`}>{newLanguage.header.command}</Link>
            </chakra.li>
            <chakra.li className={styles.navitem}>
              <Menu isOpen={isOpen} onClose={onClose}>
                <MenuButton onClick={onOpen} textTransform="uppercase">
                  {newLanguage.header.language}
                </MenuButton>
                <MenuList
                  bgColor="#001318"
                  color="white"
                  borderColor="#001318"
                  textAlign="center"
                  width="80px"
                  boxShadow="base"
                >
                  <MenuItem
                    icon={<FaFlag />}
                    onClick={() => setLanguage("pt")}
                    className={styles.menuLanguage}
                  >
                    Português
                  </MenuItem>
                  <MenuItem
                    icon={<FaFlag />}
                    onClick={() => setLanguage("en")}
                    className={styles.menuLanguage}
                  >
                    English
                  </MenuItem>
                </MenuList>
              </Menu>
            </chakra.li>
          </chakra.ol>
        </chakra.nav>
      </chakra.div>
    </chakra.div>
  );
}

function Sidebar() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} className={styles.buttonSidebar} display="none">
        <FaBars size={25} />
      </Button>
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent className={styles.sidebar}>
          <DrawerCloseButton />
          <DrawerHeader>Tanjiro#2415</DrawerHeader>

          <DrawerBody>
            <chakra.li className={styles.sidebarMenu}>
              <Link to={`/`}>INÍCIO</Link>
            </chakra.li>
            <chakra.li className={styles.sidebarMenu}>
              <Link to={`/guidelines`}>DIRETRIZES</Link>
            </chakra.li>
            <chakra.li className={styles.sidebarMenu}>
              <Link to={`/commands`}>COMANDOS</Link>
            </chakra.li>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
